import React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useCommandBarJobOpenings } from 'modules/ats/hooks/useCommandBarJobOpenings'
import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import type { JobStatus } from 'modules/ats/lib/utils/jobPosting'
import type { ResultType, SearchPlugin, SearchPluginHook } from 'modules/command_bar/lib/types'

const jobStatusToIcon: Record<JobStatus, () => React.ReactElement> = {
  draft: () => <Icon.Medium icon="input-field" />,
  published: () => <Icon.Medium icon="globe" />,
  archived: () => <Icon.Medium icon="archive" />,
  unlisted: () => <Icon.Medium icon="eye-invisible" />,
  cancelled: () => <Icon.Medium icon="deny" />,
}

const DEFAULT_SCORE = 0.2

const useJobOpeningsPlugin: SearchPluginHook = (search) => {
  const { navigation } = useNavigation()
  const { loading, data } = useCommandBarJobOpenings({ title: search })
  const { atsEnabled } = useAtsEnabled()

  const mappedResults = atsEnabled
    ? data.map(
        (job): ResultType => ({
          id: `${job.id}`,
          text: job.title,
          IconComponent: jobStatusToIcon[job.status as JobStatus],
          type: 'navigation',
          navigationPath: navigation.ats.jobs.jobsId.fullPath({ jobId: job.id }),
          score: DEFAULT_SCORE,
        })
      )
    : []

  return {
    id: 'jobOpenings',
    results: mappedResults,
    title: i18n.t('command_bar.plugins.job_openings.title'),
    loading,
  }
}

export const jobOpeningsPlugin: SearchPlugin = {
  hook: useJobOpeningsPlugin,
}
